import { defineStore } from 'pinia';
import api from '../api';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        token: localStorage.getItem('token'),
        loading: false,
        error: null,
    }),
    getters: {
        isAuthenticated: (state) => !!state.token,
    },
    actions: {
        async login(username, password) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/member/login', { username, password });
                this.token = response.data.token;
                this.user = response.data.user;
                localStorage.setItem('token', this.token);
                // Merge cart logic could go here if we supported merging guest cart
            } catch (err) {
                this.error = err.response?.data?.message || 'Login failed';
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async register(userData) {
            this.loading = true;
            this.error = null;
            try {
                const response = await api.post('/member/register', userData);
                this.token = response.data.token;
                this.user = response.data.user;
                localStorage.setItem('token', this.token);
            } catch (err) {
                this.error = err.response?.data?.message || 'Registration failed';
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async logout() {
            this.loading = true;
            try {
                await api.post('/member/logout');
            } catch (err) {
                console.error('Logout error', err);
            } finally {
                this.token = null;
                this.user = null;
                localStorage.removeItem('token');
                this.loading = false;
            }
        },

        async fetchUser() {
            if (!this.token) return;
            this.loading = true;
            try {
                const response = await api.get('/member/profile');
                this.user = response.data.user;
            } catch (err) {
                this.token = null;
                this.user = null;
                localStorage.removeItem('token');
            } finally {
                this.loading = false;
            }
        }
    }
});
